import { combineReducers } from 'redux';

import setup from './setup/reducer';

export default combineReducers({
  setup,
});



// WEBPACK FOOTER //
// ./src/pages/genericexportsetup/state/reducer.js